<template>
  <VPopup
    class="tender-orders-popup"
    position="bottom"
    show-pointer
    :visible="true"
    :target="target"
  >
    <ul>
      <li
        v-for="position in tender.orderPositions"
        :key="position.id"
      >
        <VButton
          theme="link"
          :disabled="$core.currentPartner.isSeller === true && position.seller.id !== $core.currentPartner.id"
          @click="openPositionCard(position)"
        >
          <!--Удалённая позиция остаётся в списке ссылкой, но красной: заказа по ней
          *  больше нет -->
          <span :class="{'critical': position.isDeleted === true}">
            {{ $core.utils.string.formatWithDelimiter(position.id) }}
          </span>
        </VButton>
        - {{ position.qty.format(tender.unit) }}
      </li>
    </ul>
  </VPopup>
</template>

<style lang="scss">
.tender-orders-popup {
  padding: 10px;

  li {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
}
</style>

<script lang="ts">
import TendersService from '@/domains/Tenders/TendersService';
import type Tender from '@/domains/Tenders/Tender';
import type OrderPosition from '@/domains/Orders/OrderPosition';
import {UnwrapNestedRefs} from "vue";

export default defineComponent({
  name: 'TenderOrdersPopup',

  components: {
  },

  props: {
    tender: {
      type:     Object as PropType<Tender | UnwrapNestedRefs<Tender>>,
      required: true,
    },
    /** Якорь. Не передан — попап встаёт на место контекстного меню, иначе у курсора */
    target: {
      type:    Object as PropType<HTMLElement | undefined>,
      default: undefined,
    },
  },

  emits: [
  ],

  data() {
    return {
    };
  },

  created() {
  },

  mounted() {
  },

  beforeUnmount() {
  },

  computed: {
  },

  methods: {
    /** Закрывает попап и открывает карточку выбранной позиции заказа */
    openPositionCard(position: OrderPosition): Promise<boolean> {
      this.$core.dialogs.TenderOrdersPopup.hide();

      return TendersService.showOrderPositionCard(position);
    },
  },
});
</script>
